import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ChatConversaComponent } from '../../../chat/chat-conversa/chat-conversa.component';
import { Contato } from '../../model/contato/contato.model';

@Component({
  selector: 'app-modal-component-chat',
  standalone: true,
  imports: [ChatConversaComponent],
  templateUrl: './modal-component-chat.component.html',
  styleUrl: './modal-component-chat.component.css'
})
export class ModalComponentChatComponent {
  private readonly dialogRef = inject<MatDialogRef<ModalComponentChatComponent>>(MatDialogRef);
  private readonly data = inject<{ contato?: Contato }>(MAT_DIALOG_DATA);

  readonly contato = this.data?.contato;

  onVoltar(): void {
    this.dialogRef.close('voltar');
  }

  aoEncerrarAtendimento(): void {
    this.dialogRef.close('encerrado');
  }
}
